/**
 * 연락처 단일 원천 (Single Source of Truth)
 * 전화번호/예약/지도/리뷰 URL은 여기서 관리.
 * Tigris JSON과 무관하게 코드 배포만으로 즉시 반영됨.
 */

export const PHONE_DISPLAY = '0507-1482-0316'
export const PHONE_LINK = 'tel:050714820316'
export const PHONE_INTERNATIONAL = '+82-507-1482-0316'

export const NAVER_PLACE_ID = '1996683158'
export const NAVER_BOOKING_URL = `https://m.place.naver.com/restaurant/${NAVER_PLACE_ID}/booking?entry=pll`
export const NAVER_MAP_URL = `https://m.place.naver.com/restaurant/${NAVER_PLACE_ID}/location?view=cocoa&filter=location&selected_place_id=${NAVER_PLACE_ID}`
export const NAVER_REVIEWS_URL = `https://m.place.naver.com/restaurant/${NAVER_PLACE_ID}/review/visitor?entry=ple&reviewSort=recent`

export const GOOGLE_MAPS_URL =
    'https://www.google.co.kr/maps/place/%EA%B0%80%EB%9D%BD%EC%8B%9C%EC%9E%A5+%ED%9D%91%EB%8F%BC%EC%A7%80+%EB%A7%9B%EC%A7%91+%ED%9D%91%EB%8F%881931+(blackpork1931)+Garak+Korean+Pork+BBQ/data=!3m1!4b1!4m6!3m5!1s0x357ca53f0273be57:0xd698f3be86db009c!8m2!3d37.4971619!4d127.1208555!16s%2Fg%2F11y78wfzc5?entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D'
export const DININGCODE_URL = 'https://www.diningcode.com/list.dc?query=%EA%B0%80%EB%9D%BD%EC%8B%9C%EC%9E%A5+%ED%9D%91%EB%8F%BC%EC%A7%80'
export const SIKSIN_URL = 'https://www.siksinhot.com/P/1698934'
export const BLUERIBBON_URL = 'https://www.bluer.co.kr/restaurants/42061'

export const GOOGLE_DIRECTIONS_URL =
    'https://www.google.com/maps/dir/?api=1&destination=%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C%20%EC%86%A1%ED%8C%8C%EA%B5%AC%20%EC%86%A1%ED%8C%8C%EB%8C%80%EB%A1%9C30%EA%B8%B8%2041-26%201%EC%B8%B5'
export const INSTAGRAM_TAG_URL = 'https://www.instagram.com/explore/tags/%ED%9D%91%EB%8F%881931/'
